interface Response {
  data: VersionData[]
}

interface VersionData {
  author: string
  childEngines: string
  createdAt: string
  defaultEngineType: string
  effectiveEndDate: string
  effectiveStartDate: string
  engine: string
  id: string
  isActive: boolean
  product: string
  releaseNote: string
  revision: string
  tags: string
  versionLabel: string
}

export const fetchVersions = async (): Promise<Response> => {
  return await fetch("https://excel.uat.us.coherent.global/api/v1/product/DEMOS/engines/getversions/mortgage", {
    headers: {
      "x-synthetic-key": process.env.REACT_APP_X_SYNTHETIC_KEY!,
      "x-tenant-name": process.env.REACT_APP_X_TENANT_NAME!,
    },
  }).then((response) => {
    return response.json()
  })
}

